import { Row } from '@opendoor/atoms/box';
import { Text } from '@opendoor/atoms/text';
import { formatCurrency } from '@opendoor/shared-fe/formatUtils';

interface PricingTraditionalProps {
  listPrice?: number | null;
}

export const PricingTraditional = ({ listPrice }: PricingTraditionalProps) => {
  return (
    <Row className="items-center">
      <Text as="h2" className="pb-6 text-header-md text-od-content-primary">
        {listPrice ? formatCurrency(listPrice) : 'Price not available'}
      </Text>
    </Row>
  );
};
